import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(10), // 80px margin equals the Filters Bar minHeight
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '295px',
    position: 'relative',
    top: 0,
    marginRight: theme.spacing(3),
  },
  listContainer: {
    display: 'flex',
    flexGrow: 1,
    overflow: 'hidden',
    paddingLeft: theme.spacing(1),
    [theme.breakpoints.down('xl')]: {
      paddingLeft: theme.spacing(3),
    },
  },
  list: {
    height: '100%',
    zIndex: 100,
    flex: 1,
    overflowY: 'auto',
  },
  listItem: {
    '&.Mui-selected': {
      color: theme.palette.primary.main,
      background: theme.palette.grey[900],
    },
  },
  tagDrawer: {
    flex: 1,
    overflowY: 'auto',
  },
}));

export default useStyles;
